import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'

import {
  ISiteBoxDocumentConfig,
  SiteBoxDocumentConfig,
} from '@core/entities/SiteBoxDocumentConfig'

const dataTransformer = (response: ISiteBoxDocumentConfig) =>
  SiteBoxDocumentConfig.new(response)

export const useGetSiteBoxConfiguration = (
  payload: RequestTypes['getSiteBoxConfiguration'],
  options?: UseQueryOptions<
    ISiteBoxDocumentConfig,
    RequestErrorType,
    SiteBoxDocumentConfig
  >,
) => {
  return useQuery({
    ...siteBoxDocumentsKeys.byConfigId(payload),
    select: dataTransformer,
    ...options,
  })
}
